module.exports = __webpack_public_path__ + "media/Footprints/Electricity-ed090ea1.svg";